<template>
  <page-layout>
    <template slot="header">
      <nav-mobile />
      <logo-meetrika/>
      <nav-desktop />
      <nav-ornament />
      <user-menu :user="user" v-if="user"/>
    </template>

    <template slot="content">
      <header-experiments :on-search-criteria-changed="onSearchCriteriaChanged" :is-loading="isLoading"/>
      <experiments-list
        v-if="experiments.length > 0"
        :experiments="experiments"
        :pagination="pagination"
        :on-page-changed="onPaginationChanged"
        :is-loading="true"
      />
      <experiments-no-results :message="noResultsMesssage" v-if="experiments.length == 0"/>
    </template>

    <template slot="footer">
      <footer-meetrika />
    </template>
  </page-layout>
</template>

<style scoped>

</style>

<script>
import PageLayout from '@/components/layouts/PageLayout.vue'
import NavMobile from '@/components/header/NavMobile.vue'
import LogoMeetrika from '@/components/header/LogoMeetrika.vue'
import NavDesktop from '@/components/header/NavDesktop.vue'
import NavOrnament from '@/components/header/NavOrnament.vue'
import UserMenu from '@/components/header/UserMenu.vue'
import FooterMeetrika from '@/components/footer/FooterMeetrika.vue'
import ExperimentsList from '@/components/experiments/ExperimentsList.vue'
import HeaderExperiments from '@/components/experiments/HeaderExperiments.vue'
import ExperimentsNoResults from '@/components/experiments/ExperimentsNoResults.vue'
import experimentsApi from '@/api/experiments/experiments'

export default {
  components: {
    PageLayout,
    NavMobile,
    LogoMeetrika,
    NavDesktop,
    NavOrnament,
    UserMenu,
    FooterMeetrika,
    ExperimentsList,
    HeaderExperiments,
    ExperimentsNoResults,
  },
  data() {
    return {
      experiments: [],
      pagination: {
        count: null,
        current_page: null,
        total_pages: null,
      },
      searchCriteria: {},
      noResultsMesssage: this.$t('experiments.noResults', { link: '/configuration' }),
      isLoading: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['security/user']
    },
  },
  created() {
    this.fetchExperiments()
  },
  methods: {
    onSearchCriteriaChanged(searchCriteria) {
      this.searchCriteria = Object.assign(searchCriteria, { page: 1 })
      this.fetchExperiments()
    },
    onPaginationChanged(page) {
      this.searchCriteria = Object.assign(this.searchCriteria, { page })
      this.fetchExperiments()
    },
    fetchExperiments() {
      this.isLoading = true

      experimentsApi.fetchAll(this.searchCriteria)
        .then((res) => {
          this.experiments = res.data.experiments
          this.pagination = res.data.meta

          if (this.experiments.length === 0) {
            this.noResultsMesssage = this.$t('experiments.noSearchResults')
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
